import React from "react";

export function LoaderSpinner({ absolute=true, style={}  }) {
    
    return (
        <div style={ !absolute ? {...style, position: 'relative'} : {...style}} className="loader-spinner">

			<div className="loader-spinner-element">

			</div>


        </div>
    );
}
